import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button } from "reactstrap";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Chip from '@mui/material/Chip';
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import { Checkbox } from '@mui/material';
import { user_requisition } from "../../api/requisition";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import Dashboard from "./dashboard";


const RSMDashboard = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Dashboard'))
  

    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    total: 0,
    approved: 0,
    pending: 0
  })

    document.title = "Dashboard | Procurement Dashboard";
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },]
    const handleProductNameClick = (isOpen) => {
        setOpen(isOpen)
    };
    const [showList, setShowList] = useState(false);

    const toggleList = () => {
        setShowList(!showList);
    };

    const approvalcolumns = [
        { field: 'Sl_No', flex: 1, sortable: false, resizable: false, headerName: (<div><Checkbox /><span>SL.No</span></div>), width: 100 ,
         renderCell: (params) => {
            return <div><Checkbox /><span>1</span></div>;
          },
        },
        // {
        //     field: 'Requisition_No',
        //     headerName: 'Requisition No',
        //     headerClassName: 'table-header-background',
        //     // width: 160,
        //     editable: true,
        // },
        {
            field: 'Requisition_Date',
            headerName: 'Requisition Date',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: true,
            sortable: false,
            resizable: false,
            flex: 1,
            
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'table-header-background',
            cellClassName: 'product_name_wrap',
            sortable: false,
            resizable: false,
            width: 160,
            editable: true,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Total_Qty',
            headerName: 'Total Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Allocation_QTY',
            headerName: 'Allocation (QTY)',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'remaining',
            headerName: 'Remaining',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Value',
            headerName: 'Value',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Actual_Date',
            headerName: 'Actual Date',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
        },
        {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
             resizable: false,
            width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'Waiting for response') {
                    chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                    chipColor = 'success'; // Green color for approved
                }

                // Render the Chip component with the outlined variant and appropriate color
                return <div className="mt-1"><Chip className="status_badge" label={status} variant="outlined" color={chipColor} /></div>;
            },
        },
    ];

    const approvalrows = [
        { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2, Allocation_QTY: 10, remaining: 0, Value: 5, Actual_Date: '-', Status: 'Waiting for response' },
        { id: 2, Sl_No: 2, Requisition_No: 'REQ2', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2, Allocation_QTY: 10, remaining: 0, Value: 5, Actual_Date: '-', Status: 'approved' },
    ];
    const columns = [
        { field: 'Sl_No', headerName: 'Sl.No', flex: 1, sortable: false,
        resizable: false,
        },
        {
            field: 'Requisition_No',
            headerName: 'Requisition No',
            headerClassName: 'table-header-background',
            // width: 160,
            sortable: false,
            resizable: false,
            flex: 1,
            
        },
        {
            field: 'Requisition_Date',
            headerName: 'Requisition Date',
            headerClassName: 'table-header-background',
            // width: 160,
            sortable: false,
            resizable: false,
            flex: 1,
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            sortable: false,
            resizable: false,
            // flex: 1,
            width: 160,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Total_Qty',
            headerName: 'Total Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Allocation_QTY',
            headerName: 'Allocation (QTY)',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'remaining',
            headerName: 'Remaining',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Value',
            headerName: 'Value',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Actual_Date',
            headerName: 'Actual Date',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },
        {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'Waiting for response') {
                    chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                    chipColor = 'success'; // Green color for approved
                }

                // Render the Chip component with the outlined variant and appropriate color
                return <div className="mt-1"><Chip className="status_badge" label={status} variant="outlined" color={chipColor} /></div>;
            },
        },
    ];

    const rows = [
        { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2, Allocation_QTY: 10, remaining: 0, Value: 5, Actual_Date: '-', Status: 'Waiting for response' },
        { id: 2, Sl_No: 1, Requisition_No: 'REQ2', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2, Allocation_QTY: 10, remaining: 0, Value: 5, Actual_Date: '-', Status: 'approved' },
    ];

    const fetchRequisitionHistory = async (payload = {}) => {
        try {
          setIsLoading(true)
          let count = 0; // Initialize the count variable outside the map function
          const response = await user_requisition(payload);
    
        
          if(response.statusCode ===200 && response.data.getRequisition.length >0){
            let results = response.data.getRequisition.flatMap(requisition => requisition.procurementRequisitionItem.map(item => ({
                id: item.id,
                Sl_No: ++count,
                Requisition_No: requisition.requisition_number,
                Requisition_Date:requisition.requisition_date,
                Product_Name: item.item_name,
                Total_Qty: item.total_qty,
                approved: item.approved_qty,
                remaining: item.total_qty - item.approved_qty,
                Value: item.value,
                Allocation_QTY: item.allocation_qty,
                // Actual_Date: '--',
                // Modified_Date:'--',
                Arival_Date: '--',
                Status: item.status
              })));
              setData({
                total: results.length,
                approved: results.filter(el => el.Status == 'COMPLETE_APPROVED' || el.Status == 'PARTIALLY_APPROVED' || el.Status == 'EXCESS_APPROVED' || el.Status == 'APPROVED').length,
                pending: results.filter(el => el.Status == 'APPROVAL_PENDING' || el.Status == 'SAVED' || el.Status == 'REJECTED').length

               })
          }
          
    
        } catch (error) {
          console.error('Error fetching requisition history:', error);
          toast.error('Something went wrong')
          // Handle error
        }
        finally {
          setIsLoading(false); // Reset loading state after operation completes
        }
      };
    
      useEffect(() => {
        fetchRequisitionHistory();
      }, []);

    return (
        <React.Fragment>
   
            <div className="page-content">
                <Container fluid>
              
                    <div className="w-100" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '14px' }}>
                        <div style={{width:'100%'}}>
                            {/* <h5 className="requisition_text mb-2">Approval Requisitions</h5> */}
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '17px' }}>
                                <Card className="mb-3 number_requisition">
                                    <CardBody>
                                        <CardTitle tag="h5">
                                            <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                                                <LibraryAddIcon />
                                                <span style={{ marginLeft: '8px', color:'white', fontSize:'22px',fontWeight:'600' }}>{data.total}</span>
                                            </div>
                                        </CardTitle>
                                        <CardText>
                                            <div style={{ color: 'white' }}><span style={{whiteSpace:'nowrap'}}>Total No of Requisitions</span></div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                                <Card className="mb-3 approved_requisition_card">
                                    <CardBody>
                                        <CardTitle tag="h5">
                                            <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                                                <b> <DoneAllIcon /></b>
                                                <span style={{ marginLeft: '8px', color: 'white',fontSize:'22px', fontWeight:'600' }}>{data.approved}</span>
                                            </div>
                                        </CardTitle>
                                        <CardText>
                                            <div style={{ color: 'white' }}><span>Approved</span></div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                                <Card className="mb-3 notapproved_requisition_card">
                                    <CardBody>
                                        <CardTitle tag="h5">
                                            <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                                                {/* <span><CloseIcon /></span> */}
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 22v-2H5V4h10v4h4v5h2V7l-5-5H3.999A.995.995 0 0 0 3 2.992v18.016a1 1 0 0 0 .993.992zm9.536-.879L19.414 19l2.122-2.121l-1.415-1.415l-2.12 2.122l-2.122-2.122l-1.414 1.415l2.12 2.12l-2.12 2.122l1.414 1.414L18 20.415l2.121 2.12z"/></svg></span>
                                                <span style={{ marginLeft: '8px', color: 'white', fontSize:'22px',fontWeight:'600' }}>{data.pending}</span>
                                            </div>
                                        </CardTitle>
                                        <CardText>
                                            <div style={{ color: 'white' }}><span>Not Approved</span></div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                      
                    </div>
                    <Dashboard/>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RSMDashboard;
